import { BalanceType } from '@/entities/balances'
import { CryptoWithdrawModel } from '@/entities/cryptoWithdraw'

export enum BalanceAction {
  PayInTraderCommission = 1 /** Комиссия трейдера при входящем платеже */,
  PayInMerchantCommission = 2 /** Комиссия мерчанта при входящем платеже */,
  PayOutTraderCommission = 3 /** Комиссия трейдера при исходящем платеже */,
  PayOutMerchantCommission = 4 /** Комиссия мерчанта при исходящем платеже */,
  PayInTraderReferralCommission = 5 /** Реферальная комиссия трейдера при входящем платеже */,
  PayInMerchantReferralCommission = 6 /** Реферальная комиссия мерчанта при входящем платеже */,
  PayOutTraderReferralCommission = 7 /** Реферальная комиссия трейдера при исходящем платеже */,
  PayOutMerchantReferralCommission = 8 /** Реферальная комиссия мерчанта при исходящем платеже */,
  Deposit = 9 /** Депозит (пополнение баланса) */,
  CryptoWithdraw = 10 /** Крипто-выводы */,
  AdminChange = 11 /** Ручное изменение баланса админом */,
  CryptoDeposit = 99 /** Крипто-депозиты */,
  MerchantTopupConfirmed = 100 /** Подтвержденное пополнение баланса мерчанта */,
  TopupCommission = 200 /** Комиссия, удержанная с входящего пополнения */,
  TraderTopupCreated = 300 /** Создание пополнения на баланс трейдера */,
  TraderTopupPaid = 301 /** Успешное пополнение баланса трейдера */,
  TraderTopupTimeout = 302 /** Отмена пополнения по таймауту */,
  TraderTopupCancelledByPayer = 303 /** Пополнение отменено плательщиком */,
  WithdrawCreated = 400 /** Создана заявка на фиатный вывод */,
  WithdrawFailed = 410 /** Фиатный вывод зафейлился */,
  WithdrawCancelledByAdmin = 411 /** Фиатный вывод отменен админом */,
  WithdrawPaid = 420 /** Фиатный вывод успешно совершен */,
  WithdrawPartiallyPaid = 421 /** Частично выполненный фиатный вывод */,
  WithdrawCommission = 430 /** Комиссия за фиатный вывод */,
  BalanceTransfer = 500 /** Перевод средств между балансами */,
}

export enum CryptoDepositRisk {
  NoRisk = 0,
  Risk = 1,
}

export interface FinanceModel {
  id: string
  balanceId: string
  action: BalanceAction
  balanceType: BalanceType
  amount: number
  comment: string
  cryptoWithdraw: CryptoWithdrawModel
  createdAt: string
}

export interface TraderFinanceModel extends FinanceModel {
  id: string
  userId: string
  reusableInvoiceId: string
  txHash?: string | null
  fromAddress?: string | null
  toAddress?: string | null
  amount: number
  amountUsd?: number | null
  isCollected: boolean
  risk: CryptoDepositRisk
  createdAt: string
  transactionCreatedAt: string
}

export enum FinanceStatus {
  /** Все типы */
  /** Выводы: как у Withdraw */
  /** Пополнения: как у Deposit */
  All = 1,
  /** Выводы: CryptoWithdraw, AdminChange если минус */
  Withdraw = 2,
  /** Пополнения: BalanceTransfer, Deposit, AdminChange если плюс */
  Deposit = 3,
}
